// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"0458eac9","111":"96888334","400":"f64d15a5","620":"f64d15a5","725":"8f81b815"}[chunkId] + ".chunk.css";
};